import { renderIcon } from '../helpers/renderIcon';
import { slugify } from '../helpers/slugify';
import { FETCH_CONFIG } from './config';

async function getLocations(url) {
    const response = await fetch(url, FETCH_CONFIG);
    const locations = await response.json();

    return locations;
}

function renderLocation(kindengezinPath, location) {
    const item = document.createElement('li');
    const hasContactInfo = location.email !== null && location.telefoon !== null;

    item.classList.add('location-search__locations__item');
    item.dataset.type = location.type;

    const toggle = document.createElement('button');
    toggle.classList.add(...['location-search__item__toggle', 'js-location-search-item-toggle']);

    toggle.dataset.longitude = location.xcoor;
    toggle.dataset.latitude = location.ycoor;
    toggle.dataset.closeOthersParent = '.js-location-search-locations';
    toggle.dataset.closeOther = 'true';

    const nameHolder = document.createElement('span');
    nameHolder.classList.add('location-search__item__toggle__name');
    nameHolder.textContent = location.naam;

    const addressHolder = document.createElement('small');
    addressHolder.classList.add('location-search__item__toggle__address');
    addressHolder.textContent = `${location.straat}, ${location.postcode} ${location.gemeente}`;

    if (hasContactInfo) {
        toggle.dataset.target = `#${slugify(location.naam)}`;

        const readMoreHolder = document.createElement('span');
        readMoreHolder.classList.add('location-search__item__toggle__more');
        readMoreHolder.textContent = 'Toon details';

        const readMoreIcon = renderIcon(kindengezinPath, 'chevron-down', ['location-search__item__toggle__more__icon']);

        readMoreHolder.appendChild(readMoreIcon);

        toggle.appendChild(nameHolder);
        toggle.appendChild(addressHolder);
        toggle.appendChild(readMoreHolder);
    } else {
        toggle.appendChild(nameHolder);
        toggle.appendChild(addressHolder);
    }

    item.appendChild(toggle);

    if (hasContactInfo) {
        const contactInfo = document.createElement('div');
        contactInfo.classList.add(...['js-collapsible-content', 'collapsible']);
        contactInfo.id = slugify(location.naam);

        const contactList = document.createElement('ul');
        contactList.classList.add('location-search__locations__item__contact-info');

        if (location.telefoon !== null) {
            const phoneHolder = document.createElement('li');
            phoneHolder.classList.add('location-search__locations__item__contact__item');

            const phoneLink = document.createElement('a');
            phoneLink.classList.add(...['icon-link', 'icon-link--icon-left']);
            phoneLink.href = `tel:${location.telefoon}`;
            phoneLink.textContent = location.telefoon;

            const phoneIcon = renderIcon(kindengezinPath, 'phone', ['icon-link__icon']);

            phoneLink.prepend(phoneIcon);
            phoneHolder.appendChild(phoneLink);
            contactList.appendChild(phoneHolder);
        }

        if (location.email !== null) {
            const emailHolder = document.createElement('li');
            emailHolder.classList.add('location-search__locations__item__contact__item');

            const emailLink = document.createElement('a');
            emailLink.classList.add(...['icon-link', 'icon-link--icon-left']);
            emailLink.href = `tel:${location.email}`;
            emailLink.textContent = location.email;

            const emailIcon = renderIcon(kindengezinPath, 'mail', ['icon-link__icon']);

            emailLink.prepend(emailIcon);
            emailHolder.appendChild(emailLink);
            contactList.appendChild(emailHolder);
        }

        contactInfo.appendChild(contactList);
        item.appendChild(contactInfo);
    }

    return item;
}

function renderClearSearchButton(kindengezinPath, text) {
    const button = document.createElement('button');
    button.classList.add('location-search__clear-search');
    const icon = renderIcon(kindengezinPath, 'cross', ['location-search__clear-search__icon']);
    button.textContent = text;
    button.prepend(icon);

    return button;
}

export {
    getLocations,
    renderLocation,
    renderClearSearchButton,
};
